import { NextPage } from 'next';

import SsoSelfJoinRedirect from '../components/_organisms/Auth/SsoSelfJoinRedirect';
import { ssoSelfJoinServerSideProps } from '../utils/ssoSelfJoinSsr';

const GoogleSSOLogin: NextPage<{ newAuth: boolean }> = ({ newAuth }) => (
  <SsoSelfJoinRedirect
    newAuth={newAuth}
    newProvider="google"
    azureProvider="azure-ad-b2c-googlesso-self-join"
    domainHint="google.com"
  />
);

export const getServerSideProps = ssoSelfJoinServerSideProps;

export default GoogleSSOLogin;
